/**
 * @namespace {BX.UI}
 */
export default class ProgressBarSize
{
	static MEDIUM = "ui-progressbar-md";
	static LARGE = "ui-progressbar-lg";
}
